import { useEffect } from 'react';

import { inIframe } from 'utils/browserDetect';
import { checkIsWebview } from 'utils/mobileApplication';

export function useCookieYes() {
  useEffect(() => {
    if (inIframe()) return;

    const isProductionEnv = process.env.REACT_APP_ENV === 'production';
    const notPdfView = localStorage.getItem('pdfPreview') !== 'true';

    // for testing purpose only
    const needToForceLoad = localStorage.getItem('__SP_LOAD_COOKIEYES') === '1';

    const needToLoadScript = notPdfView && (isProductionEnv || needToForceLoad) && !checkIsWebview();

    if (needToLoadScript) {
      const script = document.createElement('script');
      script.src = 'https://cdn-cookieyes.com/client_data/fff8742795d2fc5eff8d78c1/script.js';
      script.id = 'cookieyes';

      document.head.appendChild(script);
    }
  }, []);
}
